import { render, staticRenderFns } from "./ShiftBulkChangeConfirmDialog.vue?vue&type=template&id=44c964f2&lang=pug"
import script from "./ShiftBulkChangeConfirmDialog.vue?vue&type=script&lang=js"
export * from "./ShiftBulkChangeConfirmDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports